import { faCircleXmark, faUpload } from '@fortawesome/pro-solid-svg-icons';
import { faFileSlash } from '@fortawesome/pro-regular-svg-icons';

export function addTaskAttachment(task, attachment) {
  const attachments = [...task.attachments, attachment];
  return { ...task, attachments };
}

export function deleteTaskAttachment(task, attachment) {
  const changes = {
    attachments: task.attachments.filter(taskAttachment => taskAttachment.id !== attachment.id)
  };

  if (task.completed && task.requiresAttachment && changes.attachments.length === 0) {
    changes.completed = false;
  }
  return { ...task, ...changes };
}

export function hasAttachment(task, attachment) {
  return !!task.attachments.find(taskAttachment => taskAttachment.id === attachment.id);
}

export const attachmentExceptionOptions = [
  {
    icon: faUpload,
    label: 'Upload',
    value: 'none',
  },
  {
    icon: faCircleXmark,
    label: 'Not Applicable',
    value: 'not_applicable',
    hasReason: true,
  },
  {
    icon: faFileSlash,
    label: 'Not Available',
    value: 'not_available',
    hasReason: true,
  },
];
